/* 🤖 this file was generated by script */
export const wiconStatusDot = {
  name: 'status_dot',
  data: `<svg viewBox="0 0 20 20"><path fill="currentColor" fill-rule="evenodd" d="M14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd"/></svg>`,
};
